import { Pipe, PipeTransform } from '@angular/core'
import { DateTime } from 'luxon'

@Pipe({ name: 'formatChatTime', standalone: true, pure: true })
export class FormatChatTimePipe implements PipeTransform {
	transform(isoDate: string): string {
		if (!isoDate) return ''
		const dt = DateTime.fromISO(isoDate)
		return dt.isValid ? dt.toLocaleString(DateTime.DATETIME_SHORT) : ''
	}
}
